module.exports = __webpack_public_path__ + "img/497-d67498.png";